import { useState } from 'react';

import style from './PasswordInput.module.scss';
import { HidePassword, ShowPassword } from '@components/Icons/PasswordVisibility';

const PasswordInput = ({
	setPassword,
	placeholder,
	title,
	value,
	id,
}: {
	setPassword: (val: string) => void;
	placeholder: string;
	title: string;
	value: string;
	id: string;
}) => {
	const [showPassword, setShowPassword] = useState(false);

	const togglePasswordVisibility = () => {
		setShowPassword((prev) => !prev);
	};

	return (
		<div className={style['password']}>
			<label htmlFor={id}>{title}</label>
			<div className={style['password-container']}>
				<input
					id={id}
					title={title}
					type={showPassword ? 'text' : 'password'}
					onChange={(event) => setPassword(event?.target.value)}
					placeholder={placeholder}
					value={value}
				/>
				<button
					type='button'
					aria-label={showPassword ? 'Скрыть пароль' : 'Показать пароль'}
					className={style['password-container-toggle-password']}
					onClick={togglePasswordVisibility}
				>
					{showPassword ? <ShowPassword /> : <HidePassword />}
				</button>
			</div>
		</div>
	);
};

export default PasswordInput;
